import React, { useRef, useState } from "react";
import { useClickAway } from "react-use";
import { LogOut } from "lucide-react";
import * as analytics from "@/services/analytics";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";

interface Props {
  avatarSrc: string;
}

export const ProfileMenu: React.FC<Props> = ({ avatarSrc }) => {
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const user = useAuthenticatedUser();

  useClickAway(menuRef, () => {
    if (profileMenuOpen) {
      setProfileMenuOpen(false);
    }
  });

  const handleLogout = () => {
    analytics.logout();
  };

  return (
    <div className="relative mt-4" ref={menuRef}>
      <div
        className="flex cursor-pointer items-center gap-x-2 rounded-md px-2 py-1.5 transition-colors duration-200 ease-in-out hover:bg-white hover:text-gray-600"
        onClick={() => setProfileMenuOpen(!profileMenuOpen)}
      >
        <img src={avatarSrc} alt="Profile" width={20} height={20} className="rounded-full" />
        <div className="text-atriablue-500 text-sm font-semibold">
          {user.name} {user.surname}
        </div>
      </div>
      {profileMenuOpen && (
        <div className="absolute -top-14 right-0 z-50 mb-2 w-full rounded-md bg-white p-2 shadow-lg">
          <a
            href="/pf-auth/logout"
            onClick={handleLogout}
            className="text-atriablue-500 flex w-full items-center gap-x-2 rounded-md px-2 py-1.5 text-left text-sm font-semibold transition-colors duration-200 ease-in-out hover:bg-white hover:text-gray-600"
          >
            <LogOut size={18} />
            <span>Logout</span>
          </a>
        </div>
      )}
    </div>
  );
};
